module.exports = __webpack_public_path__ + "img/chevy.5f16f40d.png";